<template>
  <div :style="{marginTop:mt,marginBottom:mb,textAlign:ta}">{{text}}</div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    mt: {
      default: '0px'
    },
    mb: {
      default: '0px'
    },
    ta: {
      default: 'left'
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~assets/styles/varibles.styl'

div
  height 40px
  line-height 40px
  padding-left 16px
  font2()
  font-size 12px
  background $themeColor3
  color #ffffff


</style>



// WEBPACK FOOTER //
// src/components/base/header/BlockHeader.vue